<span
    [raskPopover]="template"
    [disablePopover]="popoverDisabled"
    [closeDelay]="300"
    [triggers]="triggers"
    container="body"
    popoverClass="rask-icon-popover {{popoverClass}}"
    #ngbPopover="raskPopover"
    (click)="onOpen(ngbPopover)"
    [ngClass]="{ 'fa-stack': true, 'clickable': clickToOpen === true }">
    <i [ngClass]="icon" class="fa-stack-1x"></i>
    <i [ngClass]="icon2" class="fa-stack-1x"></i>
</span>

<ng-template #template>
    {{text}}
    <ng-content></ng-content>
</ng-template>

<div #templateResult style="display: none;">
    <ng-container *ngTemplateOutlet="template"></ng-container>
</div>